(ns dre.components.dropdown
  (:require
    [applied-science.js-interop :as j]
    [dre.utils.bem :as bem]
    [reagent.core :as r]))


(def component-name :dropdown)


(defn- handle-click
  [id open? ev]
  (letfn [(in-content?
            [el]
            (when-let [el-id (j/get el :id)]
              (= el-id id)))
          (clicked-outside?
            []
            (->> (.composedPath ev)
                 (map in-content?)
                 (not-any? true?)))]
    (when (clicked-outside?)
      (reset! open? false))
    true))


(defn- handle-keypress
  [open? ev]
  (if (= (j/get ev :key) "Escape")
    (reset! open? false)
    true))


(defn dropdown
  [_]
  (let [open? (r/atom false)
        id (str (random-uuid))]
    (r/create-class
      {:display-name "dropdown"

       :component-did-mount
       #(doto js/window
          (.addEventListener "click" (partial handle-click id open?))
          (.addEventListener "keydown" (partial handle-keypress open?)))

       :component-will-unmount
       #(doto js/window
          (.removeEventListener "click" (partial handle-click id open?))
          (.removeEventListener "keydown" (partial handle-keypress open?)))

       :reagent-render
       (fn [{:keys [anchor content alignment class]
             :or {alignment :left}}]
         [:div
          {:id id
           :class (r/class-names component-name class)}
          [:div
           {:class (bem/bem component-name :anchor (when @open? :open))
            :on-click (fn [e]
                        (.preventDefault e)
                        #_(.stopPropagation e)
                        (swap! open? not))}
           anchor]
          (when @open?
            [:div
             {:class (bem/bem component-name :content alignment)}
             (if (fn? (first content)) ;; Is content a function component?
               (conj content open?)    ;; Pass "open?" r/atom as last prop
               content)])])})))


(defn dropdown-list
  [items open?]
  [:ul
   {:class (bem/be component-name :list)}
   (for [[idx item] (map-indexed vector items)]
     ^{:key idx}
     [:li
      {:class (bem/be component-name :list-item)
       :on-click (fn [e]
                   (.stopPropagation e)
                   (reset! open? false))}
      item])])
